<template>
  <BaseFormGroup
    data-class="base-text-input-field"
    class="base-text-input-field"
    :columnInfo="columnInfo"
    v-if="columnInfo.visible()"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <BaseTextInput
      v-model="_value"
      :columnInfo="columnInfo"
      :type="type"
      :error-visible="errorVisible"
      :rules="rules"
      :maxLength="maxLength"
      :minLength="minLength"
      :state="state"
      v-bind="$attrs"
      v-on="$listeners"
    />
  </BaseFormGroup>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'BaseTextInputField',

  inheritAttrs: false,

  props: {
    value: {
      type: [String, Number],
      default: '',
    },

    /**
     * 定義情報.
     * @type {Object}
     * @requires
     */
    columnInfo: {
      type: Object,
      required: true,
    },

    /**
     * バリデーションチェックの状態を表示するか.
     * @type {Boolean}
     */
    state: {
      type: Boolean,
      default: false,
    },

    /**
     * 入力検証ルール.
     * @type {String}
     */
    rules: {
      type: Array,
      default: () => [],
    },

    /**
     * エラーメッセージを表示するか.
     * @type {Boolean}
     */
    errorVisible: {
      type: Boolean,
      default: true,
    },

    type: {
      type: String,
      default: 'text',
    },

    maxLength: {
      type: [String, Number],
    },

    minLength: {
      type: [String, Number],
    },
  },

  computed: {
    _value: {
      get() {
        return _.isNil(this.value) ? this.value : String(this.value)
      },

      set(v) {
        if (this.value !== v) this.$emit('input', v)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.base-text-input-field {
  margin: 0;
  padding: 0;
}
</style>
